// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__20Yav","rootSuccess":"CompleteLink_rootSuccess__2fLik","rootFailure":"CompleteLink_rootFailure__14vfO","isDisabled":"CompleteLink_isDisabled__3q4yG"};